import React from 'react';
import { connect } from 'react-redux';
import format from 'string-template';

import { MODAL_TYPE_LOGIN } from '../../../services/modal/constants';

import { showModal } from '../../../services/modal/actions';

import RegisterFormComponent from './RegisterFormComponent';

import './RegisterModalComponent.scss';

class RegisterModalComponent extends React.Component {
    showLoginModal = () => this.props.showModal(MODAL_TYPE_LOGIN);

    render() {
        const { i18n, BRAND_NAME } = this.props;
        return (
            <div className="modal-register-form">
                <h1>{i18n.TITLE}</h1>
                <RegisterFormComponent />
                <p className={'txtcenter'}>
                    {format(i18n.ALREADY_REGISTERED_TEXT, BRAND_NAME)}{' '}
                    <span className="fakelink" onClick={this.showLoginModal}>
                        {i18n.CONNECT_ME}
                    </span>
                </p>
            </div>
        );
    }
}

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.register,
        BRAND_NAME: state.i18n.common.BRAND_NAME
    };
};

const mapDispatchToProps = {
    showModal
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterModalComponent);



// WEBPACK FOOTER //
// ./src/components/authentication/register/RegisterModalComponent.js